// import React, { useEffect, useState } from "react";
// import {
//     Grid,
//     Typography,
//     Paper,
//     Box,
//     Button,
//     Chip,
//     Divider,
//     Stack,
//     Avatar,
//     CircularProgress,
//     alpha,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import MainCard from "ui-component/cards/MainCard";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import PendingActionsIcon from "@mui/icons-material/PendingActions";
// import PersonIcon from "@mui/icons-material/Person";
// import EmailIcon from "@mui/icons-material/Email";
// import PhoneIcon from "@mui/icons-material/Phone";
// import BusinessIcon from "@mui/icons-material/Business";
// import WorkIcon from "@mui/icons-material/Work";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// const EntryApprovalDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const API = process.env.REACT_APP_API_URL;
//     const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//     const [entryApproval, setEntryApproval] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [updatingStatus, setUpdatingStatus] = useState(false);
//     const [sendingPass, setSendingPass] = useState(false);

//     // --- Helpers ---
//     const formatDate = (date) => {
//         if (!date) return "-";
//         return new Date(date).toLocaleString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//             hour: "2-digit",
//             minute: "2-digit",
//         });
//     };

//     const getStatusChip = (status) => {
//         const commonStyles = {
//             fontWeight: 500,
//             px: 1.5,
//             py: 0.5,
//             borderRadius: "12px",
//             fontSize: "0.8rem",
//         };
//         switch (status) {
//             case "accept":
//                 return (
//                     <Chip
//                         icon={<CheckCircleIcon />}
//                         label="Accepted"
//                         sx={{
//                             ...commonStyles,
//                             backgroundColor: alpha("#4caf50", 0.15),
//                             color: "#2e7d32",
//                         }}
//                     />
//                 );
//             case "reject":
//                 return (
//                     <Chip
//                         icon={<CancelIcon />}
//                         label="Rejected"
//                         sx={{
//                             ...commonStyles,
//                             backgroundColor: alpha("#f44336", 0.15),
//                             color: "#b71c1c",
//                         }}
//                     />
//                 );
//             default:
//                 return (
//                     <Chip
//                         icon={<PendingActionsIcon />}
//                         label="Pending"
//                         sx={{
//                             ...commonStyles,
//                             backgroundColor: alpha("#ffeb3b", 0.25),
//                             color: "#7c6f00",
//                         }}
//                     />
//                 );
//         }
//     };

//     // --- API Calls ---
//     const fetchEntryApproval = async () => {
//         try {
//             const response = await fetch(`${API}entry-approval-details/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${localStorage.getItem("token")}`,
//                     authkey: AUTH_KEY,
//                 },
//             });

//             const data = await response.json();
//             if (response.ok && data?.data?.entryApproval) {
//                 setEntryApproval(data.data.entryApproval);
//             } else {
//                 toast.error("Failed to fetch entry approval details");
//                 navigate(-1);
//             }
//         } catch (error) {
//             toast.error("Something went wrong while fetching details");
//             navigate(-1);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const updateEntryStatus = async (entryId, action, fullName) => {
//         const actionText = action === "accept" ? "Accept" : "Reject";
//         const confirm = await swal({
//             title: `${actionText} ${fullName}?`,
//             text: `Are you sure you want to ${actionText.toLowerCase()} this Entry approval?`,
//             icon: action === "accept" ? "success" : "error",
//             buttons: ["Cancel", actionText],
//             dangerMode: action === "reject",
//         });

//         if (!confirm) return;

//         try {
//             setUpdatingStatus(true);
//             const response = await fetch(`${API}update-entry-approval-status/${entryId}`, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${localStorage.getItem("token")}`,
//                     authkey: AUTH_KEY,
//                 },
//                 body: JSON.stringify({ status: action }),
//             });

//             const data = await response.json();
//             if (response.ok) {
//                 toast.success(`Entry ${action === "accept" ? "accepted" : "rejected"} successfully`);
//                 setEntryApproval((prev) => ({ ...prev, status: action }));
//             } else {
//                 toast.error(data.message || "Failed to update status");
//             }
//         } catch (error) {
//             toast.error("Error updating status");
//         } finally {
//             setUpdatingStatus(false);
//         }
//     };

//     const sendGatePass = async (entryId, fullName) => {
//         try {
//             setSendingPass(true);
//             const response = await fetch(`${API}send-entry-gate-pass/${entryId}`, {
//                 method: "POST",
//                 headers: {
//                     Authorization: `Bearer ${localStorage.getItem("token")}`,
//                     authkey: AUTH_KEY,
//                 },
//             });
//             const data = await response.json();
//             if (response.ok) {
//                 toast.success(`Gate pass sent to ${fullName}`);
//             } else {
//                 toast.error(data.message || "Failed to send gate pass");
//             }
//         } catch (error) {
//             toast.error("Error sending gate pass");
//         } finally {
//             setSendingPass(false);
//         }
//     };

//     useEffect(() => {
//         fetchEntryApproval();
//         // eslint-disable-next-line
//     }, [id, updatingStatus]);

//     if (loading)
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
//                 <CircularProgress />
//             </Box>
//         );

//     if (!entryApproval)
//         return (
//             <Typography textAlign="center" variant="h6" color="text.secondary">
//                 No details found.
//             </Typography>
//         );

//     const {
//         fullName,
//         email,
//         employeeId,
//         department,
//         designation,
//         contactNumber,
//         visitStart,
//         visitEnd,
//         status,
//         createdAt,
//         updatedAt,
//         locationAreaAccessed,
//         purposeOfEntryAfterHours,
//         departmentJustification,
//     } = entryApproval;

//     return (
//         <MainCard>
//             <Grid container spacing={3}>
//                 {/* Header */}
//                 <Grid item xs={12}>
//                     <Box
//                         sx={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             mb: 2,
//                         }}
//                     >
//                         <Stack direction="row" spacing={2} alignItems="center">
//                             <Avatar sx={{ bgcolor: "primary.main", color: "#fff", width: 60, height: 60 }}>
//                                 {fullName ? fullName.charAt(0).toUpperCase() : "U"}
//                             </Avatar>
//                             <Box>
//                                 <Typography variant="h5" sx={{ fontWeight: 600, textTransform: "capitalize" }}>
//                                     {fullName}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                     {employeeId}
//                                 </Typography>
//                             </Box>
//                         </Stack>
//                         {getStatusChip(status)}
//                     </Box>
//                 </Grid>

//                 {/* Basic Information */}
//                 <Grid item xs={12}>
//                     <Paper
//                         sx={{
//                             border: "1px solid #2196f3",
//                             backgroundColor: "#f9fbff",
//                             borderRadius: 2,
//                             p: 2.5,
//                         }}
//                     >
//                         <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                             <PersonIcon color="primary" />
//                             <Typography variant="subtitle1" fontWeight={600}>
//                                 Basic Information
//                             </Typography>
//                         </Stack>
//                         <Divider sx={{ mb: 2 }} />

//                         <Grid container spacing={2}>
//                             <Grid item xs={12} sm={6}>
//                                 <Stack spacing={1}>
//                                     <Typography><b>Full Name:</b> {fullName || "-"}</Typography>
//                                     <Typography><b>Email:</b> {email || "-"}</Typography>
//                                     <Typography><b>Contact Number:</b> {contactNumber || "-"}</Typography>
//                                 </Stack>
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <Stack spacing={1}>
//                                     <Typography><b>Department:</b> {department.name || "-"}</Typography>
//                                     <Typography><b>Designation:</b> {designation || "-"}</Typography>
//                                 </Stack>
//                             </Grid>
//                         </Grid>
//                     </Paper>
//                 </Grid>

//                 {/* Visit Information */}
//                 <Grid item xs={12}>
//                     <Paper
//                         sx={{
//                             border: "1px solid #e0e0e0",
//                             backgroundColor: "#fff",
//                             borderRadius: 2,
//                             p: 2.5,
//                         }}
//                     >
//                         <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                             <CalendarMonthIcon color="primary" />
//                             <Typography variant="subtitle1" fontWeight={600}>
//                                 Visit Information
//                             </Typography>
//                         </Stack>
//                         <Divider sx={{ mb: 2 }} />

//                         <Grid container spacing={2}>
//                             <Grid item xs={6}>
//                                 <Typography>
//                                     <b>Visit Start:</b> <span style={{ color: "#2e7d32" }}>{formatDate(visitStart)}</span>
//                                 </Typography>
//                             </Grid>
//                             <Grid item xs={6}>
//                                 <Typography>
//                                     <b>Visit End:</b>{" "}
//                                     <span style={{ color: "#d32f2f" }}>{formatDate(visitEnd)}</span>
//                                 </Typography>
//                             </Grid>
//                             <Grid item xs={6}>
//                                 <Typography><b>Location Accessed:</b> {locationAreaAccessed || "-"}</Typography>
//                             </Grid>
//                             <Grid item xs={6}>
//                                 <Typography><b>Purpose of Entry:</b> {purposeOfEntryAfterHours || "-"}</Typography>
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <Typography><b>Department Justification:</b> {departmentJustification || "-"}</Typography>
//                             </Grid>
//                         </Grid>
//                     </Paper>
//                 </Grid>

//                 {entryApproval.qrCode?.url && (
//                     <Grid item xs={12}>
//                         <Paper
//                             sx={{
//                                 border: "1px solid #e0e0e0",
//                                 backgroundColor: "#fff",
//                                 borderRadius: 2,
//                                 p: 2.5,
//                                 textAlign: "center",
//                             }}
//                         >
//                             <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={1}>
//                                 <img
//                                     src={entryApproval.qrCode.url}
//                                     alt="QR Code"
//                                     style={{
//                                         width: 160,
//                                         height: 160,
//                                         border: "1px solid #ddd",
//                                         borderRadius: 12,
//                                         backgroundColor: "#fff",
//                                     }}
//                                 />
//                             </Stack>
//                             <Typography variant="subtitle1" color="text.secondary">
//                                 QR Code for Entry Pass
//                             </Typography>
//                         </Paper>
//                     </Grid>
//                 )}

//                 {entryApproval.scanHistory?.length > 0 && (
//                     <Grid item xs={12}>
//                         <Paper
//                             sx={{
//                                 border: "1px solid #e0e0e0",
//                                 backgroundColor: "#fff",
//                                 borderRadius: 2,
//                                 p: 2.5,
//                             }}
//                         >
//                             <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                                 <Typography variant="subtitle1" fontWeight={600}>
//                                     Scan History
//                                 </Typography>
//                             </Stack>
//                             <Divider sx={{ mb: 2 }} />

//                             <Box sx={{ overflowX: "auto" }}>
//                                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                                     <thead>
//                                         <tr style={{ backgroundColor: "#f5f5f5" }}>
//                                             <th style={{ padding: "8px", textAlign: "left" }}>Scan Time</th>
//                                             <th style={{ padding: "8px", textAlign: "left" }}>Status Code</th>
//                                             <th style={{ padding: "8px", textAlign: "left" }}>Validity</th>
//                                             <th style={{ padding: "8px", textAlign: "left" }}>Reason</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {entryApproval.scanHistory.map((scan) => (
//                                             <tr key={scan._id} style={{ borderBottom: "1px solid #eee" }}>
//                                                 <td style={{ padding: "8px" }}>{formatDate(scan.scanTime)}</td>
//                                                 <td style={{ padding: "8px" }}>{scan.statusCode}</td>
//                                                 <td style={{ padding: "8px" }}>
//                                                     {scan.isValid ? (
//                                                         <Chip label="Valid" color="success" size="small" />
//                                                     ) : (
//                                                         <Chip label="Invalid" color="error" size="small" />
//                                                     )}
//                                                 </td>
//                                                 <td style={{ padding: "8px" }}>{scan.reason || "-"}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </Box>
//                         </Paper>
//                     </Grid>
//                 )}

//                 {/* System Information */}
//                 <Grid item xs={12}>
//                     <Paper
//                         sx={{
//                             border: "1px solid #e0e0e0",
//                             backgroundColor: "#fafafa",
//                             borderRadius: 2,
//                             p: 2,
//                         }}
//                     >
//                         <Grid container spacing={2}>
//                             <Grid item xs={6}>
//                                 <Typography>
//                                     <b>Created At:</b> {formatDate(createdAt)}
//                                 </Typography>
//                             </Grid>
//                             <Grid item xs={6}>
//                                 <Typography textAlign="right">
//                                     <b>Last Updated:</b> {formatDate(updatedAt)}
//                                 </Typography>
//                             </Grid>
//                         </Grid>
//                     </Paper>
//                 </Grid>

//                 {/* Action Buttons */}
//                 <Grid item xs={12}>
//                     <Divider sx={{ mb: 2 }} />
//                     <Stack direction="row" spacing={2} justifyContent="flex-start">
//                         {status === "pending" && (
//                             <>
//                                 <Button
//                                     variant="contained"
//                                     sx={{
//                                         backgroundColor: "#2e7d32",
//                                         "&:hover": { backgroundColor: "#1b5e20" },
//                                     }}
//                                     disabled={updatingStatus}
//                                     onClick={() => updateEntryStatus(entryApproval._id, "accept", fullName)}
//                                 >
//                                     {updatingStatus ? <CircularProgress size={20} color="inherit" /> : "Accept Entry"}
//                                 </Button>

//                                 <Button
//                                     variant="contained"
//                                     sx={{
//                                         backgroundColor: "#d32f2f",
//                                         "&:hover": { backgroundColor: "#b71c1c" },
//                                     }}
//                                     disabled={updatingStatus}
//                                     onClick={() => updateEntryStatus(entryApproval._id, "reject", fullName)}
//                                 >
//                                     {updatingStatus ? <CircularProgress size={20} color="inherit" /> : "Reject Entry"}
//                                 </Button>
//                             </>
//                         )}

//                         {status === "accept" && (
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 disabled={sendingPass}
//                                 onClick={() => sendGatePass(entryApproval._id, fullName)}
//                             >
//                                 {sendingPass ? <CircularProgress size={20} color="inherit" /> : "Send Gate Pass"}
//                             </Button>
//                         )}

//                         <Button
//                             variant="outlined"
//                             startIcon={<ArrowBackIcon />}
//                             onClick={() => navigate(-1)}
//                             sx={{ borderColor: "#1976d2", color: "#1976d2" }}
//                         >
//                             Back To List
//                         </Button>
//                     </Stack>
//                 </Grid>
//             </Grid>
//         </MainCard>
//     );
// };

// export default EntryApprovalDetails;

// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import {
//   User,
//   Calendar,
//   FileText,
//   QrCode,
//   Clock,
//   ArrowLeft,
//   CheckCircle,
//   XCircle,
//   AlertCircle,
//   Mail,
//   Building,
//   MapPin,
//   IdCard,
//   Phone,
//   Briefcase,
// } from "lucide-react";
// import styles from "./entryApprovalDetails.module.css";

// const EntryApprovalDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const API = process.env.REACT_APP_API_URL;
//   const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//   const [entryApproval, setEntryApproval] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case "accept":
//         return (
//           <div className={`${styles.badge} ${styles.badgeAccepted}`}>
//             <CheckCircle size={16} />
//             <span>Accepted</span>
//           </div>
//         );
//       case "reject":
//         return (
//           <div className={`${styles.badge} ${styles.badgeRejected}`}>
//             <XCircle size={16} />
//             <span>Rejected</span>
//           </div>
//         );
//       default:
//         return (
//           <div className={`${styles.badge} ${styles.badgePending}`}>
//             <AlertCircle size={16} />
//             <span>Pending</span>
//           </div>
//         );
//     }
//   };

//   const fetchEntryApproval = async () => {
//     try {
//       const response = await fetch(`${API}entry-approval-details/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok && data?.data?.entryApproval) {
//         setEntryApproval(data.data.entryApproval);
//       } else {
//         toast.error("Failed to fetch entry approval details");
//         navigate(-1);
//       }
//     } catch (error) {
//       toast.error("Something went wrong while fetching details");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateEntryStatus = async (action, fullName) => {
//     const actionText = action === "accept" ? "Accept" : "Reject";

//     const confirm = await swal({
//       title: `${actionText} ${fullName}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this entry approval?`,
//       icon: action === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: action === "reject",
//     });

//     if (!confirm) return;

//     try {
//       setUpdatingStatus(true);
//       const response = await fetch(
//         `${API}update-entry-approval-status/${entryApproval._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             authkey: AUTH_KEY,
//           },
//           body: JSON.stringify({ status: action }),
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Entry ${action === "accept" ? "accepted" : "rejected"} successfully`);
//         setEntryApproval((prev) => ({ ...prev, status: action }));
//       } else {
//         toast.error(data.message || "Failed to update status");
//       }
//     } catch (error) {
//       toast.error("Error updating status");
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const sendGatePass = async () => {
//     try {
//       setSendingPass(true);
//       const response = await fetch(`${API}send-entry-gate-pass/${entryApproval._id}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Gate pass sent successfully`);
//       } else {
//         toast.error(data.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       toast.error("Error sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   useEffect(() => {
//     fetchEntryApproval();
//   }, [id, updatingStatus]);

//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.spinner}></div>
//       </div>
//     );
//   }

//   if (!entryApproval) {
//     return (
//       <div className={styles.noData}>
//         <p>No details found.</p>
//       </div>
//     );
//   }

//   const {
//     fullName,
//     email,
//     employeeId,
//     department,
//     designation,
//     contactNumber,
//     visitStart,
//     visitEnd,
//     status,
//     createdAt,
//     updatedAt,
//     locationAreaAccessed,
//     purposeOfEntryAfterHours,
//     departmentJustification,
//     qrCode,
//     scanHistory,
//   } = entryApproval;

//   return (
//     <div className={styles.container}>
//       {/* Header Section */}
//       <div className={styles.header}>
//         <div className={styles.headerLeft}>
//           <div className={styles.avatar}>
//             <User size={32} />
//           </div>
//           <div className={styles.headerInfo}>
//             <h1 className={styles.title}>
//               {fullName}
//             </h1>
//             <div className={styles.metaInfo}>
//               <span className={styles.metaItem}>
//                 <IdCard size={14} />
//                 {employeeId}
//               </span>
//               <span className={styles.metaItem}>
//                 <Building size={14} />
//                 {department?.name || "N/A"}
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className={styles.headerRight}>{getStatusBadge(status)}</div>
//       </div>

//       {/* Basic Information Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <User size={20} />
//           <h2>Basic Information</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.detailsGrid}>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Full Name</span>
//               <span className={styles.value}>{fullName || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Email</span>
//               <span className={styles.value}>{email || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Contact Number</span>
//               <span className={styles.value}>{contactNumber || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Employee ID</span>
//               <span className={styles.value}>{employeeId || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Department</span>
//               <span className={styles.value}>{department?.name || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Designation</span>
//               <span className={styles.value}>{designation || "-"}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Visit Information Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <Calendar size={20} />
//           <h2>Visit Information</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.detailsGrid}>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Visit Start</span>
//               <span className={styles.value}>{formatDate(visitStart)}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Visit End</span>
//               <span className={styles.value}>{formatDate(visitEnd)}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Location Accessed</span>
//               <span className={styles.value}>{locationAreaAccessed || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Purpose of Entry</span>
//               <span className={styles.value}>{purposeOfEntryAfterHours || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Department Justification</span>
//               <span className={styles.value}>{departmentJustification || "-"}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* QR Code Section */}
//       {qrCode?.url && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <QrCode size={20} />
//             <h2>Entry Pass QR Code</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.qrCodeContainer}>
//               <img src={qrCode.url} alt="QR Code" className={styles.qrCodeImage} />
//               <p className={styles.qrCodeLabel}>Scan for Entry Verification</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Scan History Section */}
//       {scanHistory && scanHistory.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <Clock size={20} />
//             <h2>Scan History</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.tableWrapper}>
//               <table className={styles.table}>
//                 <thead>
//                   <tr>
//                     <th>Scan Time</th>
//                     <th>Status Code</th>
//                     <th>Validity</th>
//                     <th>Reason</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {scanHistory.map((scan) => (
//                     <tr key={scan._id}>
//                       <td>{formatDate(scan.scanTime)}</td>
//                       <td>{scan.statusCode}</td>
//                       <td>
//                         {scan.isValid ? (
//                           <span className={styles.validBadge}>Valid</span>
//                         ) : (
//                           <span className={styles.invalidBadge}>Invalid</span>
//                         )}
//                       </td>
//                       <td>{scan.reason || "-"}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* System Info */}
//       <div className={styles.systemInfo}>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Created At:</span>
//           <span className={styles.value}>{formatDate(createdAt)}</span>
//         </div>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Last Updated:</span>
//           <span className={styles.value}>{formatDate(updatedAt)}</span>
//         </div>
//       </div>

//       {/* Action Buttons */}
//       <div className={styles.actions}>
//         {status === "pending" && (
//           <>
//             <button
//               className={`${styles.btn} ${styles.btnAccept}`}
//               disabled={updatingStatus}
//               onClick={() => updateEntryStatus("accept", fullName)}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <CheckCircle size={18} />
//                   Accept Entry
//                 </>
//               )}
//             </button>

//             <button
//               className={`${styles.btn} ${styles.btnReject}`}
//               disabled={updatingStatus}
//               onClick={() => updateEntryStatus("reject", fullName)}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <XCircle size={18} />
//                   Reject Entry
//                 </>
//               )}
//             </button>
//           </>
//         )}

//         {status === "accept" && (
//           <button
//             className={`${styles.btn} ${styles.btnPrimary}`}
//             disabled={sendingPass}
//             onClick={sendGatePass}
//           >
//             {sendingPass ? (
//               <div className={styles.btnSpinner}></div>
//             ) : (
//               <>
//                 <Mail size={18} />
//                 Send Gate Pass
//               </>
//             )}
//           </button>
//         )}

//         <button
//           className={`${styles.btn} ${styles.btnOutline}`}
//           onClick={() => navigate(-1)}
//         >
//           <ArrowLeft size={18} />
//           Back To List
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EntryApprovalDetails;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import {
  User,
  Calendar,
  FileText,
  QrCode,
  Clock,
  ArrowLeft,
  CheckCircle,
  XCircle,
  AlertCircle,
  Mail,
  Building,
  IdCard,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./entryApprovalDetails.module.css";

const EntryApprovalDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;
  const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

  const [entryApproval, setEntryApproval] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "accept":
        return (
          <div className={`${styles.badge} ${styles.badgeAccepted}`}>
            <CheckCircle size={16} />
            <span>{t("entryApprovalDetails.accepted")}</span>
          </div>
        );
      case "reject":
        return (
          <div className={`${styles.badge} ${styles.badgeRejected}`}>
            <XCircle size={16} />
            <span>{t("entryApprovalDetails.rejected")}</span>
          </div>
        );
      default:
        return (
          <div className={`${styles.badge} ${styles.badgePending}`}>
            <AlertCircle size={16} />
            <span>{t("entryApprovalDetails.pending")}</span>
          </div>
        );
    }
  };

  const fetchEntryApproval = async () => {
    try {
      const response = await fetch(`${API}entry-approval-details/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
      });
      const data = await response.json();
      if (response.ok && data?.data?.entryApproval) {
        setEntryApproval(data.data.entryApproval);
      } else {
        toast.error(t("entryApprovalDetails.fetchError"));
        navigate(-1);
      }
    } catch (error) {
      toast.error(t("entryApprovalDetails.fetchError"));
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  // const updateEntryStatus = async (action, fullName) => {
  //   const actionText =
  //     action === "accept"
  //       ? t("entryApprovalDetails.confirmAccept.title")
  //       : t("entryApprovalDetails.confirmReject.title");

  //   const confirm = await swal({
  //     title: `${actionText} ${fullName}?`,
  //     text:
  //       action === "accept"
  //         ? t("entryApprovalDetails.confirmAccept.text")
  //         : t("entryApprovalDetails.confirmReject.text"),
  //     icon: action === "accept" ? "success" : "error",
  //     buttons: [
  //       t("entryApprovalDetails.confirmDialog.cancel"),
  //       action === "accept"
  //         ? t("entryApprovalDetails.confirmDialog.accept")
  //         : t("entryApprovalDetails.confirmDialog.reject"),
  //     ],
  //     dangerMode: action === "reject",
  //   });

  //   if (!confirm) return;

  //   try {
  //     setUpdatingStatus(true);
  //     const response = await fetch(`${API}update-entry-approval-status/${entryApproval._id}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //       },
  //       body: JSON.stringify({ status: action, lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(
  //         action === "accept"
  //           ? t("entryApprovalDetails.status.acceptedSuccess")
  //           : t("entryApprovalDetails.status.rejectedSuccess"),
  //       );
  //       setEntryApproval((prev) => ({ ...prev, status: action }));
  //     } else {
  //       toast.error(data.message || t("entryApprovalDetails.updateError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("entryApprovalDetails.updateError"));
  //   } finally {
  //     setUpdatingStatus(false);
  //   }
  // };

  // const sendGatePass = async () => {
  //   try {
  //     setSendingPass(true);
  //     const response = await fetch(`${API}send-entry-gate-pass/${entryApproval._id}`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(t("entryApprovalDetails.sendSuccess"));
  //     } else {
  //       toast.error(data.message || t("entryApprovalDetails.sendError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("entryApprovalDetails.sendError"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateEntryStatus = async (action, fullName) => {
    if (updatingStatus) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("entryApprovalDetails.chooseLanguageTitle"),
      text: t("entryApprovalDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      action === "accept"
        ? t("entryApprovalDetails.confirmAccept.title")
        : t("entryApprovalDetails.confirmReject.title");

    // STEP 2: Confirmation
    const confirm = await swal({
      title: `${actionText} ${fullName}?`,
      text:
        action === "accept"
          ? t("entryApprovalDetails.confirmAccept.text")
          : t("entryApprovalDetails.confirmReject.text"),
      icon: action === "accept" ? "success" : "error",
      buttons: [
        t("entryApprovalDetails.confirmDialog.cancel"),
        action === "accept"
          ? t("entryApprovalDetails.confirmDialog.accept")
          : t("entryApprovalDetails.confirmDialog.reject"),
      ],
      dangerMode: action === "reject",
    });

    if (!confirm) return;

    try {
      setUpdatingStatus(true);

      const response = await fetch(`${API}update-entry-approval-status/${entryApproval._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
        body: JSON.stringify({
          status: action,
          lang: langChoice, // ✅ explicit language
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(
          action === "accept"
            ? t("entryApprovalDetails.status.acceptedSuccess")
            : t("entryApprovalDetails.status.rejectedSuccess"),
        );

        setEntryApproval((prev) => ({
          ...prev,
          status: action,
        }));
      } else {
        toast.error(data.message || t("entryApprovalDetails.updateError"));
      }
    } catch (error) {
      toast.error(t("entryApprovalDetails.updateError"));
    } finally {
      setUpdatingStatus(false);
    }
  };

  const sendGatePass = async () => {
    const langChoice = await swal({
      title: t("entryApprovalDetails.chooseLanguageTitle"),
      text: t("entryApprovalDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    try {
      setSendingPass(true);
      const response = await fetch(`${API}send-entry-gate-pass/${entryApproval._id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(t("entryApprovalDetails.sendSuccess"));
      } else {
        toast.error(data.message || t("entryApprovalDetails.sendError"));
      }
    } catch (error) {
      toast.error(t("entryApprovalDetails.sendError"));
    } finally {
      setSendingPass(false);
    }
  };

  useEffect(() => {
    fetchEntryApproval();
  }, [id, updatingStatus]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
      </div>
    );
  }

  if (!entryApproval) {
    return (
      <div className={styles.noData}>
        <p>{t("entryApprovalDetails.noData")}</p>
      </div>
    );
  }

  const {
    fullName,
    email,
    employeeId,
    department,
    designation,
    contactNumber,
    visitStart,
    visitEnd,
    status,
    createdAt,
    updatedAt,
    locationAreaAccessed,
    purposeOfEntryAfterHours,
    departmentJustification,
    qrCode,
    scanHistory,
    staff_status,
  } = entryApproval;

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.avatar}>
            <User size={32} />
          </div>
          <div className={styles.headerInfo}>
            <h1 className={styles.title}>{fullName}</h1>
            <div className={styles.metaInfo}>
              <span className={styles.metaItem}>
                <IdCard size={14} />
                {employeeId}
              </span>
              <span className={styles.metaItem}>
                <Building size={14} />
                {department?.name || "N/A"}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.headerRight}>{getStatusBadge(status)}</div>
      </div>

      {/* Basic Information */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <User size={20} />
          <h2>{t("entryApprovalDetails.basicInfo.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.detailsGrid}>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.basicInfo.fullName")}</span>
              <span className={styles.value}>{fullName || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.basicInfo.email")}</span>
              <span className={styles.value}>{email || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>
                {t("entryApprovalDetails.basicInfo.contactNumber")}
              </span>
              <span className={styles.value}>{contactNumber || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.basicInfo.employeeId")}</span>
              <span className={styles.value}>{employeeId || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.basicInfo.department")}</span>
              <span className={styles.value}>{department?.name || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>
                {t("entryApprovalDetails.basicInfo.designation")}
              </span>
              <span className={styles.value}>{designation || "-"}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Visit Info */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <Calendar size={20} />
          <h2>{t("entryApprovalDetails.visitInfo.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.detailsGrid}>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.visitInfo.visitStart")}</span>
              <span className={styles.value}>{formatDate(visitStart)}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.visitInfo.visitEnd")}</span>
              <span className={styles.value}>{formatDate(visitEnd)}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>
                {t("entryApprovalDetails.visitInfo.locationAccessed")}
              </span>
              <span className={styles.value}>{locationAreaAccessed || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>{t("entryApprovalDetails.visitInfo.purpose")}</span>
              <span className={styles.value}>{purposeOfEntryAfterHours || "-"}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.label}>
                {t("entryApprovalDetails.visitInfo.justification")}
              </span>
              <span className={styles.value}>{departmentJustification || "-"}</span>
            </div>
          </div>
        </div>
      </div>

      {/* QR Code */}
      {qrCode?.url && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <QrCode size={20} />
            <h2>{t("entryApprovalDetails.qr.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.qrCodeContainer}>
              <img src={qrCode.url} alt="QR Code" className={styles.qrCodeImage} />
              <p className={styles.qrCodeLabel}>{t("entryApprovalDetails.qr.label")}</p>
            </div>
          </div>
        </div>
      )}

      {/* Scan History */}
      {scanHistory && scanHistory.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <Clock size={20} />
            <h2>{t("entryApprovalDetails.scanHistory.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>{t("entryApprovalDetails.scanHistory.time")}</th>
                    <th>{t("entryApprovalDetails.scanHistory.statusCode")}</th>
                    <th>{t("entryApprovalDetails.scanHistory.validity")}</th>
                    <th>{t("entryApprovalDetails.scanHistory.reason")}</th>
                  </tr>
                </thead>
                <tbody>
                  {scanHistory.map((scan) => (
                    <tr key={scan._id}>
                      <td>{formatDate(scan.scanTime)}</td>
                      <td>{scan.statusCode}</td>
                      <td>
                        {scan.isValid ? (
                          <span className={styles.validBadge}>
                            {t("entryApprovalDetails.scanHistory.valid")}
                          </span>
                        ) : (
                          <span className={styles.invalidBadge}>
                            {t("entryApprovalDetails.scanHistory.invalid")}
                          </span>
                        )}
                      </td>
                      <td>{scan.reason || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* System Info */}
      <div className={styles.systemInfo}>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("entryApprovalDetails.system.createdAt")}</span>
          <span className={styles.value}>{formatDate(createdAt)}</span>
        </div>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("entryApprovalDetails.system.updatedAt")}</span>
          <span className={styles.value}>{formatDate(updatedAt)}</span>
        </div>
      </div>

      {/* Actions */}
      <div className={styles.actions}>
        {status === "pending" && staff_status !== "reject" && (
          <>
            <button
              className={`${styles.btn} ${styles.btnAccept}`}
              disabled={updatingStatus}
              onClick={() => updateEntryStatus("accept", fullName)}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <CheckCircle size={18} />
                  {t("entryApprovalDetails.buttons.accept")}
                </>
              )}
            </button>

            <button
              className={`${styles.btn} ${styles.btnReject}`}
              disabled={updatingStatus}
              onClick={() => updateEntryStatus("reject", fullName)}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <XCircle size={18} />
                  {t("entryApprovalDetails.buttons.reject")}
                </>
              )}
            </button>
          </>
        )}

        {status === "accept" && (
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={sendingPass}
            onClick={sendGatePass}
          >
            {sendingPass ? (
              <div className={styles.btnSpinner}></div>
            ) : (
              <>
                <Mail size={18} />
                {t("entryApprovalDetails.buttons.sendPass")}
              </>
            )}
          </button>
        )}

        <button className={`${styles.btn} ${styles.btnOutline}`} onClick={() => navigate(-1)}>
          <ArrowLeft size={18} />
          {t("entryApprovalDetails.buttons.back")}
        </button>
      </div>
    </div>
  );
};

export default EntryApprovalDetails;
